


















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter } from 'vuex-class'
import { PushTemplate, DataTableAction, CrudDialogMode } from '../utils/types'
import DataTable from '../components/DataTable.vue'
import PushTemplateCrud from '../components/PushTemplateCrud.vue'
import { DataTableHeader } from 'vuetify'
import { makeGqlRequest } from '../utils/helpers'
import { getPushTemplates } from '../utils/queries'
import { updatePushTemplate } from '../utils/mutations'
import { createPushTemplate } from '../utils/api'
import dayjs from 'dayjs'
import _ from 'lodash'

@Component({
  components: { PushTemplateCrud, DataTable }
})
export default class PushTemplates extends Vue {
  @Getter jwt!: string

  currentCrudDialogMode = CrudDialogMode.NONE
  CrudDialogMode = CrudDialogMode
  headers: DataTableHeader[] = [
    { text: 'כותרת', value: 'title' },
    { text: 'תוכן', value: 'content' },
    { text: 'קישור', value: 'formattedLink' },
    { text: 'זמן יצירה', value: 'formattedCreatedAt' },
    { text: 'פושים שנוצרו', value: 'totalCreatedCount' },
    { text: 'נשלחו בהצלחה', value: 'totalSentCount' },
    { text: 'נפתחו', value: 'totalOpenedCount' }
  ]

  isLoading = false
  isViewingArchive = false
  itemsPerPage = 100
  currentPage = 1
  selectedTemplate: PushTemplate | null = null
  pushTemplates: PushTemplate[] = []
  totalTemplates = 0

  snackbar = false
  snackbarMessage = ''

  get actions(): DataTableAction<PushTemplate>[] {
    return [
      {
        text: this.isViewingArchive ? 'החזרה מהארכיון' : 'העברה לארכיון',
        icon: 'mdi-archive',
        handler: (item) => this.openCrudDialog(item, CrudDialogMode.DELETE)
      },
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: (item) => this.openCrudDialog(item, CrudDialogMode.EDIT)
      }
    ]
  }

  get currentDialogTitle() {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        return 'יצירת תבנית חדשה'
      case CrudDialogMode.EDIT:
        return 'עריכת תבנית'
      case CrudDialogMode.DELETE:
        return 'האם את/ה בטוח/ה?'
      default:
        return ''
    }
  }

  get formattedPushTemplates() {
    return this.pushTemplates.map((item) => ({
      ...item,
      formattedLink: _.truncate(item.link ?? '', { length: 50 }),
      formattedCreatedAt: item.createdAt
        ? dayjs(item.createdAt).format('DD/MM/YYYY')
        : ''
    }))
  }

  get isDialogOpen() {
    return this.currentCrudDialogMode !== CrudDialogMode.NONE
  }

  async mounted() {
    await this.fetchPage(1)
  }

  closeCrudDialog() {
    this.currentCrudDialogMode = CrudDialogMode.NONE
    this.selectedTemplate = null
  }

  async handleCrudDialogSubmit(templateItem: PushTemplate) {
    this.isLoading = true
    try {
      if (this.currentCrudDialogMode === CrudDialogMode.CREATE) {
        await createPushTemplate(
          {
            title: templateItem.title,
            content: templateItem.content,
            notes: templateItem.notes || null,
            link: templateItem.link || null
          },
          this.jwt
        )
        this.snackbarMessage = 'התבנית נוצרה בהצלחה'
      } else if (this.currentCrudDialogMode === CrudDialogMode.EDIT) {
        await makeGqlRequest(
          updatePushTemplate,
          {
            id: templateItem.id,
            title: templateItem.title,
            content: templateItem.content,
            notes: templateItem.notes || null,
            link: templateItem.link || null
          },
          this.jwt
        )
        this.snackbarMessage = 'התבנית עודכנה בהצלחה'
      } else if (this.currentCrudDialogMode === CrudDialogMode.DELETE) {
        await makeGqlRequest(
          updatePushTemplate,
          {
            id: templateItem.id,
            isArchived: !this.isViewingArchive
          },
          this.jwt
        )
        this.snackbarMessage = this.isViewingArchive
          ? 'התבנית שוחזרה בהצלחה'
          : 'התבנית הועברה לארכיון'
      }
      this.snackbar = true
      this.closeCrudDialog()
      await this.fetchPage(this.currentPage)
    } catch (err) {
      this.snackbarMessage = 'שגיאה: ' + (err.message || err)
      this.snackbar = true
    } finally {
      this.isLoading = false
    }
  }

  async fetchPage(page: number): Promise<void> {
    this.currentPage = page
    this.isLoading = true
    try {
      const res = await makeGqlRequest(
        getPushTemplates,
        {
          limit: this.itemsPerPage,
          page,
          isArchived: this.isViewingArchive
        },
        this.jwt
      )
      this.pushTemplates = res.pushTemplates?.templates || []
      this.totalTemplates = res.pushTemplates?.count || 0
    } catch (err) {
      this.snackbarMessage = 'שגיאה בטעינת תבניות: ' + (err.message || err)
      this.snackbar = true
    } finally {
      this.isLoading = false
    }
  }

  async handleTableTabChanged(tab: number) {
    this.isViewingArchive = !!tab
    await this.fetchPage(1)
  }

  openCrudDialog(
    templateItem: PushTemplate | null = null,
    mode: CrudDialogMode = CrudDialogMode.CREATE
  ) {
    this.selectedTemplate = templateItem
    this.currentCrudDialogMode = mode
  }
}
